import { ITotalRecords } from './common.model';

export class FileExtension {
  constructor(
    public extension: string,
    public description: string,
    public category = ''
  ) {}
}

export interface IFileUploadMetadata {
  fileSectionId: number;
  fileOriginId?: number;
}

export interface IFileDto extends ITotalRecords  {
  id: number;
  courseName: string;
  board: number | any;
  class: number | any;
  subject: number | any;
  chapter: number | any;
  topic: number | any;
  boardName: string;
  className: string;
  subjectName: string;
  chapterName: string;
  topicName: string;
  fileDetails: IFileDetailsDto[];
}

export interface IFileDetailsDto {
  id: number;
  fileId?: number;
  fileName: string;
  title: string;
  fileExtension: string;
  fileSize: number;
  order: number;
}
